/** Sub-Produkt-Icons (Logo-Mark v3) — Footer & Querverweise t05 */
export const T05_ICON_BASE = '/landing/t05/icons/v3';

export type T05FooterProduct = {
  id: string;
  label: string;
  route: string;
  iconFile: string;
};

export const T05_FOOTER_PRODUCTS: T05FooterProduct[] = [
  { id: 'orbis', label: 'Orbis', route: '/produkt/orbis', iconFile: 'icon-orbis.jpg' },
  { id: 'arko', label: 'ARKO', route: '/produkt/arko', iconFile: 'icon-arko.jpg' },
  { id: 'dokumente', label: 'Dokumente', route: '/produkt/dokumente', iconFile: 'icon-dokumente.jpg' },
  {
    id: 'litigation',
    label: 'Litigation',
    route: '/produkt/litigation-engine',
    iconFile: 'icon-litigation.jpg',
  },
  { id: 'lexcore', label: 'LEXCORE', route: '/produkt/lexcore', iconFile: 'icon-lexcore.jpg' },
  { id: 'diktat', label: 'Diktat', route: '/produkt/diktat', iconFile: 'icon-diktat.jpg' },
  { id: 'portal', label: 'Portal', route: '/produkt/portal', iconFile: 'icon-portal.jpg' },
  { id: 'recht', label: 'Rechtliches', route: '/recht', iconFile: 'icon-recht.jpg' },
];

export function t05ProductIconSrc(iconFile: string): string {
  return `${T05_ICON_BASE}/${iconFile}`;
}
